// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__67O2B","spinner":"Spinner_spinner__S0CLL","dot":"Spinner_dot__M_auM","dotAnimation":"Spinner_dotAnimation__Ax9zu"};